import React, { useEffect, useState } from "react";
import styles from "./Timer.module.css";

interface TimeLeft {
  hours: number;
  minutes: number;
  seconds: number;
}

export const Timer: React.FC = () => {
  const [timeLeft, setTimeLeft] = useState<TimeLeft>({ 
    hours: 0, 
    minutes: 0, 
    seconds: 0 
  });

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date();
      const endOfDay = new Date(
        now.getFullYear(), 
        now.getMonth(), 
        now.getDate() + 1, 
        0, 0, 0
      );
      const timeDiff = endOfDay.getTime() - now.getTime();

      const hoursLeft = Math.floor(timeDiff / (1000 * 60 * 60));
      const minutesLeft = Math.floor(
        (timeDiff % (1000 * 60 * 60)) / (1000 * 60)
      );
      const secondsLeft = Math.floor((timeDiff % (1000 * 60)) / 1000);

      setTimeLeft({ 
        hours: hoursLeft, 
        minutes: minutesLeft, 
        seconds: secondsLeft 
      });
    };

    // Первичный расчет
    calculateTimeLeft();
    
    // Обновление каждую секунду
    const timer = setInterval(calculateTimeLeft, 1000);
    
    // Очистка при демонтировании
    return () => clearInterval(timer);
  }, []);

  return (
    <div className={styles.timer}>
      <svg
        width="18"
        height="20"
        viewBox="0 0 18 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={styles.timerIcon}
      >
        <path
          d="M8.52941 11.4211V7.63158M17 4.78947L15.1176 2.89474M6.64706 1H10.4118M8.52941 19C6.53249 19 4.61735 18.2015 3.20531 16.7802C1.79328 15.3589 1 13.4311 1 11.4211C1 9.41099 1.79328 7.48326 3.20531 6.06193C4.61735 4.6406 6.53249 3.84211 8.52941 3.84211C10.5263 3.84211 12.4415 4.6406 13.8535 6.06193C15.2655 7.48326 16.0588 9.41099 16.0588 11.4211C16.0588 13.4311 15.2655 15.3589 13.8535 16.7802C12.4415 18.2015 10.5263 19 8.52941 19Z"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <div className={styles.timerText}>
        <span className={styles.timerDigit}>{String(timeLeft.hours).padStart(2, "0")}</span>
        <span className={styles.timerSeparator}>h : </span>
        <span className={styles.timerDigit}>{String(timeLeft.minutes).padStart(2, "0")}</span>
        <span className={styles.timerSeparator}>m : </span>
        <span className={styles.timerDigit}>{String(timeLeft.seconds).padStart(2, "0")}</span>
        <span className={styles.timerSeparator}>s</span>
      </div>
    </div>
  );
};